<template>
  <v-main>
    <v-container fluid class="fill-height">
      <v-row>
        <v-col>
          <v-card class="mx-auto" max-width="600px">
            <v-toolbar color="secondary" dark>
              <v-toolbar-title>{{ title }}</v-toolbar-title>
              <v-btn color="secondary" class="ma-2" fab x-small @click="openInfo">
                <v-icon>mdi-information-variant</v-icon>
              </v-btn>
              <v-spacer></v-spacer>
              <File />
            </v-toolbar>
            <FilesView />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <Information ref="info" />
  </v-main>
</template>

<script>
import FilesView from "@/components/views/FilesView";
import Information from "@/components/dialogs/Information";
import File from "@/components/dialogs/File";
export default {
  name: "Files",
  components: {
    FilesView,
    File,
    Information
  },
  data: () => ({
    title: "Your Files",
    btnTitle: "Add",
    dialogMessage: {
      title: "About Files",
      text: [
        "You can upload images of some your medical files",
        
      ]
    }
  }),
  methods: {
    openInfo() {
      this.$refs.info.openDialog(this.dialogMessage);
    }
  }
}
</script>

<style>
</style>